import { render, staticRenderFns } from "./KnowledgeList.vue?vue&type=template&id=c85c9322&scoped=true&"
import script from "./KnowledgeList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeList.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeList.vue?vue&type=style&index=0&id=c85c9322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85c9322",
  null
  
)

export default component.exports